import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getMesureTypes(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMesureType>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/mesuretype', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMesureType>>(JSON.parse(data),AloDbMesureType.createAloDbMesureTypeArray)
      }]
    })
  },
  getMesureType(id:number):AxiosPromise<AlrContainer<AloDbMesureType>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/mesuretype/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMesureType>(JSON.parse(data),AloDbMesureType.createAloDbMesureTypeWithDetail)
      }]
    })
  },
  saveMesureType(umbType:AloDbMesureType):AxiosPromise<AlrContainer<AloDbMesureType>> {
    if(umbType.MET_ID && umbType.MET_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/mesuretype/${umbType.MET_ID}`, 
        method: 'PUT',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMesureType>(JSON.parse(data),AloDbMesureType.createAloDbMesureTypeWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/mesuretype`, 
        method: 'POST',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMesureType>(JSON.parse(data),AloDbMesureType.createAloDbMesureTypeWithDetail)
        }]
      })    
    }
    
  }
  
}